// import axios from "axios";
// import { API_URL } from "../../utils/url-constants";
// import { decryptAEStoString, toastEmitter } from "../../utils/utilities";
// import { clearLoggedUserReducer } from "../redux/slice/logged-user";
// import { clearAdminAccessTokenReducer } from "../redux/slice/admin-access-token";
// import { store } from "../redux/store";


// const axioAdmin = axios.create({
//     baseURL: `${API_URL.baseURL}`,
// });
// axioAdmin.interceptors.request.use(
//     (config) => {
//         let state = store.getState(),
//             rawAccessToken = state?.adminAccessToken?.value;
//         rawAccessToken = rawAccessToken
//             ? decryptAEStoString(rawAccessToken)
//             : rawAccessToken;
//         if (rawAccessToken) {
//             config.headers.Authorization = `Bearer ${rawAccessToken}`;
//             config.headers['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains; preload';
//             config.headers['Referrer-Policy'] = 'no-referrer-when-downgrade';
//             config.headers['Content-Security-Policy'] = "default-src 'self'; script-src 'self' https://trusted-scripts.com;object - src 'none'; ";
//             config.headers['X-Frame-Options'] = 'DENY';
//             config.headers['X-Content-Type-Options'] = 'nosniff';
//             config.headers['X-XSS-Protection'] = '1; mode=block';
//             config.headers['Cache-control'] = 'no-cache'
//         }
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );
// axioAdmin.interceptors.response.use(
//     (response) => {
//         return response;
//     },
//     (error) => {
//         if (error.response.status === 401|| error.code==="ERR_NETWORK") {
//             store.dispatch(clearLoggedUserReducer());
//             store.dispatch(clearAdminAccessTokenReducer());
//             // window.location.href = process.env.PUBLIC_URL + "/admin/login";  
//             return toastEmitter("error", "Session expired, Please login again!");   
//         }

//         return Promise.reject(error);
//     }
// );


import axios from "axios";
import { API_URL } from "../../utils/url-constants";
import { decryptAEStoString, toastEmitter } from "../../utils/utilities";
import { clearLoggedUserReducer } from "../redux/slice/logged-user";
import { clearAdminAccessTokenReducer } from "../redux/slice/admin-access-token";
import { store } from "../redux/store";

// Create an axios instance with a base URL
const axioAdmin = axios.create({
  baseURL: API_URL.baseURL,
});

let is401ErrorEncountered = false; // Flag to track if a 401 error was encountered

// Request Interceptor
axioAdmin.interceptors.request.use(
  (config) => {
    // Block further requests if a 401 error was previously encountered
    if (is401ErrorEncountered) {
      return Promise.reject(new Error("Request blocked due to session expiration."));
    }

    // Retrieve and decrypt the access token
    const state = store.getState();
    let rawAccessToken = state?.adminAccessToken?.value;
    rawAccessToken = rawAccessToken ? decryptAEStoString(rawAccessToken) : null;

    // Add Authorization header if access token exists
    if (rawAccessToken) {
      config.headers.Authorization = `Bearer ${rawAccessToken}`;
    }

    // Add security-related headers
    // config.headers['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains; preload';
    // config.headers['Referrer-Policy'] = 'no-referrer-when-downgrade';
    // config.headers['Content-Security-Policy'] ="default-src 'self'; connect-src 'self' http://10.192.91.222:7001/; img-src 'self' http://10.192.91.222:7001/;";
    // config.headers['X-Frame-Options'] = 'DENY';
    // config.headers['X-Content-Type-Options'] = 'nosniff';
    // config.headers['X-XSS-Protection'] = '1; mode=block';
    // config.headers['Cache-Control'] = 'no-cache';

    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Response Interceptor
axioAdmin.interceptors.response.use(
  (response) => response, // Directly return response if no error
  (error) => {
    // Handle 401 Unauthorized errors or network errors
    if ((error.response?.status === 401 || error.code === "ERR_NETWORK") && !is401ErrorEncountered) {
      is401ErrorEncountered = true; // Set the flag to prevent multiple triggers
      // Clear user data from Redux store
      store.dispatch(clearLoggedUserReducer());
      store.dispatch(clearAdminAccessTokenReducer());
      
      // Emit a toast notification to inform the user
    //   window.location.href = process.env.PUBLIC_URL + "/admin/login";

      toastEmitter("error", "Session expired, Please login again!");

      // Optional: Redirect to login page
    //   setTimeout(() => {
    //     window.location.href = process.env.PUBLIC_URL + "/admin/login";
    // }, 2000);

      // Return a rejected Promise with a custom error message
      return Promise.reject(new Error("Unauthorized access - please log in again."));
    }

    // Reject other errors
    return Promise.reject(error);
  }
);

export default axioAdmin;
